module.exports = __webpack_public_path__ + "img/u338.9989c7bd.svg";